module.exports = __webpack_public_path__ + "static/dupont-9c38d78298a106eae8d72d79bb22a9c5.png";